export default __webpack_public_path__ + "static/media/home-guardian-logo.8a7b586d.png";